import React from 'react';
import { useAsync } from 'react-use';
import { isEmpty, omit, } from 'lodash';

import { functions } from '../../firebase';
import SettingsPage from '../hocs/SettingsPage';
import useDocumentSubscription from '../hooks/useDocumentSubscription';
import { createOperationLog } from '../../utils';
import { isAllowedIpAddress, } from '../../shared/ipAddress';
import { ipRestrictionSettingsFields, parseAllowedIpAddresses, } from '../../shared/models/company';
import ModelFormModal from '../modals/ModelFormModal';
import EditButton from '../EditButton';

const grantIpAccess = functions.httpsCallable('grantIpAccess');

export default SettingsPage(function CompanyIpRestrictionSettings (props) {
  const { company, } = props;
  const securityRef = company.ref.collection('companySecrets').doc('security');
  const security = useDocumentSubscription(securityRef, [company.id]);
  const { value: currentIp, loading: isLoadingCurrentIp, } = useAsync(async () => (await grantIpAccess({ companyId: company.id })).data.ip, [company.id]);
  const allowedIpAddresses = security?.allowedIpAddresses || [];
  const ipRestrictionEnabled = company.ipRestrictionEnabled === true;
  const isCurrentIpAllowed = isAllowedIpAddress(currentIp, allowedIpAddresses);
  const item = { ipRestrictionEnabled, allowedIpAddresses: allowedIpAddresses.join('\n'), };
  const validateOnSubmit = (values) => {
    return values.ipRestrictionEnabled !== true
      || isAllowedIpAddress(currentIp, parseAllowedIpAddresses(values.allowedIpAddresses))
      || window.confirm(`現在のIPアドレス（${currentIp || '不明'}）が許可リストに含まれていません。\nこのまま保存すると、このIPアドレスからはアクセスできなくなります。よろしいですか？`);
  };
  const processValues = async (values) => {
    await securityRef.set({ allowedIpAddresses: parseAllowedIpAddresses(values.allowedIpAddresses) }, { merge: true });
    return omit(values, 'allowedIpAddresses');
  };
  const onFinish = (values) => {
    return createOperationLog(company, 'ipRestrictionSetting', 'update', {
      data: { ipRestrictionEnabled: values.ipRestrictionEnabled, allowedIpAddresses: parseAllowedIpAddresses(values.allowedIpAddresses) },
      prevData: { ipRestrictionEnabled, allowedIpAddresses },
    });
  };

  if(company.usesIpRestriction !== true) return null;

  return props.translate(
    <div className="company-ip-restriction-settings container">
      <div className="d-flex justify-content-center mb-2">
        <h4>IPアドレス制限</h4>
      </div>
      <div className="d-flex justify-content-end mb-3">
        <EditButton color="primary" itemRef={company.ref} item={item} FormModal={ModelFormModal} formProps={{ title: 'IPアドレス制限', fields: ipRestrictionSettingsFields({ currentIp }), documentName: 'ipRestrictionSetting', }} validateOnSubmit={validateOnSubmit} processValues={processValues} onFinish={onFinish} disabled={isLoadingCurrentIp} />
      </div>
      {
        ipRestrictionEnabled && currentIp && !isCurrentIpAllowed && (
          <div className="alert alert-warning">
            現在のIPアドレスが許可リストに含まれていません。
          </div>
        )
      }
      <div>
        <table className="table table-bordered">
          <tbody className="thead-light">
            <tr>
              <th style={{ width: 300 }}>現在のIPアドレス</th>
              <td>
                {isLoadingCurrentIp ? <span className="fas fa-spin fa-spinner" /> : (currentIp || '取得できませんでした')}
                {!isLoadingCurrentIp && currentIp && (
                  isCurrentIpAllowed ? <span className="badge badge-success ml-2">許可済み</span> : <span className="badge badge-secondary ml-2">未許可</span>
                )}
              </td>
            </tr>
            <tr>
              <th>IPアドレス制限を有効にする</th>
              <td>{ipRestrictionEnabled ? 'はい' : 'いいえ'}</td>
            </tr>
            <tr>
              <th>許可IPアドレス</th>
              <td style={{ whiteSpace: 'pre-line' }}>
                {isEmpty(allowedIpAddresses) ? <span className="text-muted">登録されていません</span> : allowedIpAddresses.join('\n')}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
});
